import crud from '@/crud/form/form'
import resources from '../../resources'
import data from './data'
import methods from './methods'
import validations from './validations'

export default {
  data,
  methods,
  validations,

  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/professional/company/employees/form/resources/index.js